
import { Price } from "../../common/models/string-data.model";
import { ProposalStatus, ProposalType } from "../constants/buy-basic-data";

export class ProposalModif {

    id = 0;

    proposerId = "";
    customerId = "";
    providerId = ""
    carId = "";
    offerId = "";

    proposedPrice: Price= Price.getDefault();

    appointmentDate = "";
    comment = "";
    //rescheduleDate = "";

    created = "";
    lastUpdated = "";
    createdBy = "";
    lastUpdatedBy = "";

    status: ProposalStatus = ProposalStatus.SENT;
    type: ProposalType = ProposalType.BUY;

     constructor(){
        this.proposedPrice = Price.getDefault();
     }
}

